export enum CommunicationStatus {
  Read = 1,
  Unread = 2,
}
